import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import SectionContainer from '../layout/SectionContainer.jsx';
import SectionNav from '../layout/SectionNav.jsx';
import WelcomeScreen from '../layout/WelcomeScreen.jsx';

import SelfieCamera from '../components/SelfieCamera.jsx';
import face from './assets/face.json';
import { getTextDefaults } from './translations/FaceSectionTranslation.js';
import Typography from '@mui/material/Typography';

const FaceSectionWelcome = ({ text }) => {
	return (
		<WelcomeScreen animation={face}>
			<Typography variant="h6">{text.title}</Typography>
			<Typography dangerouslySetInnerHTML={{ __html: text.reason }} />
		</WelcomeScreen>
	);
};

const FaceSection = ({
	background = 'light',
	style = {},
	textOverride = {},
	navigationProps,
	uploadUrl = '/api/files',
	fileType = 'face',
	cameraIncludes,
	onChange = () => {},
	name = 'userFace',
	addPendingAction = () => {},
	removePendingAction = () => {},
	selectedLanguage = 'EN',
	disabled = false,
}) => {
	const text = Object.assign({}, getTextDefaults(selectedLanguage), textOverride);
	const [currentScreen, setCurrentScreen] = useState('welcome');

	// Ugly fix: values from onChange must persist before .next is triggered
	useEffect(() => {
		if (currentScreen === 'submit') {
			setCurrentScreen();
			navigationProps.next({ preventDefault: () => {} });
		}
	}, [currentScreen]);

	const handleBackPress = () => setCurrentScreen('welcome');

	const handleSelfieComplete = (evt) => {
		onChange(evt);
		setCurrentScreen('submit');
	};

	const viewportLayout = {
		height: '100vh',
		maxHeight: '100dvh',
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
	};

	return (
		<SectionContainer
			style={{
				...style,
				...viewportLayout,
				...(currentScreen === 'camera' ? { justifyContent: 'center' } : {}),
			}}
			background={background}
		>
			{/* Welcome */}
			{currentScreen === 'welcome' && (
				<>
					<FaceSectionWelcome text={text} />
					<SectionNav
						{...navigationProps}
						next={() => setCurrentScreen(disabled ? 'welcome' : 'camera')}
						navigation={{ nextLabel: text.getStarted }}
						hasPrevious={false}
						hasNext={true}
						inline
					/>
				</>
			)}

			{/* Camera - self-contained flow: preview → evaluate → result */}
			{currentScreen === 'camera' && (
				<Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', width: '100%' }}>
					<SelfieCamera
					cameraIncludes={cameraIncludes}
					onBackPress={handleBackPress}
					onComplete={handleSelfieComplete}
					uploadUrl={uploadUrl}
					fileType={fileType}
					name={name}
					addPendingAction={addPendingAction}
					removePendingAction={removePendingAction}
					text={text}
					getTextDefaults={getTextDefaults}
				/>
				</Box>
			)}
		</SectionContainer>
	);
};

FaceSection.type = 'FaceSection';
FaceSection.hasNavigation = true;

export default FaceSection;
